/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A custom query parameter to be used for authentication. Automatically added by the backend.
 * @export
 * @interface CustomAuthQueryParam
 */
export interface CustomAuthQueryParam {
    /**
     * The name of the query parameter.
     * @type {string}
     * @memberof CustomAuthQueryParam
     */
    name: string;
    /**
     * The value of the query parameter, represented as a Golang text/template expression. Only the backend will interpret this.
     * @type {string}
     * @memberof CustomAuthQueryParam
     */
    valueTemplate: string;
}

/**
 * Check if a given object implements the CustomAuthQueryParam interface.
 */
export function instanceOfCustomAuthQueryParam(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "valueTemplate" in value;

    return isInstance;
}

export function CustomAuthQueryParamFromJSON(json: any): CustomAuthQueryParam {
    return CustomAuthQueryParamFromJSONTyped(json, false);
}

export function CustomAuthQueryParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthQueryParam {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'valueTemplate': json['valueTemplate'],
    };
}

export function CustomAuthQueryParamToJSON(value?: CustomAuthQueryParam | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'valueTemplate': value.valueTemplate,
    };
}

